export default __webpack_public_path__ + "static/media/emptycirclePlus.471c311e.svg";